const colors = {
  backgroundGrey: "#A2A8AB",
  textWhite: "#EDECED",
  textBlack: "#131411",
  blue: "#253D5B",
  dimGrey: "#67697C",
};

export { colors };
